export const environment = {
  production: true,
  regApiGatewayUrl: 'https://p1mspzzdc4.execute-api.eu-west-3.amazonaws.com/prod/',

  firebaseConfig: {
    'firebaseTrade':{
    apiKey: 'AIzaSyAtXSGyT_VPhw_4CaQTkHB0uPDwJ3zFEok',
    authDomain: 'e-trade-bd.firebaseapp.com',
    databaseURL: 'https://e-trade-bd-default-rtdb.europe-west1.firebasedatabase.app',
    projectId: 'e-trade-bd',
    storageBucket: 'e-trade-bd.appspot.com',
    messagingSenderId: '709868566667',
    appId: '1:709868566667:web:dd16c22ee9adda5a7f7c8e',
    measurementId: 'G-86XHPWZC9D'
  },
    'firebaseMarche':{
  apiKey: "AIzaSyAhmOG5nBAjGC7rX2DJqllJD9aNl8uJUH8",
  authDomain: "resumemarche.firebaseapp.com",
  databaseURL: "https://resumemarche-default-rtdb.firebaseio.com",
  projectId: "resumemarche",
  storageBucket: "resumemarche.appspot.com",
  messagingSenderId: "712542614727",
  appId: "1:712542614727:web:0fddb126e1831131c47ae2",
  measurementId: "G-ZQ7NZCS74D"
  }

},
  DATA_LENGTH: 1200
}

